import type { MantineColor } from '@mantine/core'

export type filter = {
  key: string
  value: string
}

export type CategoryItem = {
  imgUrl: string
  text: string
  subText?: string
  subTextColor?: MantineColor
  url: string
  active: boolean
  color?: MantineColor
  isGradient: boolean
  colorFrom?: string
  colorTo?: string
}

export const providers: filter[] = [
  {
    key: '1',
    value: 'all',
  },
  {
    key: '2',
    value: 'game',
  },
  {
    key: '3',
    value: 'casino',
  },
]

export const sorts: filter[] = [
  {
    key: '1',
    value: 'Name',
  },
  {
    key: '2',
    value: 'Price',
  },
  {
    key: '3',
    value: 'Newest',
  },
  {
    key: '4',
    value: 'Oldest',
  },
]

export const searchCategories: CategoryItem[] = [
  {
    imgUrl: '/assets/search/1.svg',
    text: 'All games',
    url: '#',
    active: true,
    isGradient: true,
    colorFrom: '#DBFE02',
    colorTo: '#44FF66',
  },
  {
    imgUrl: '/assets/search/2.svg',
    text: 'Prime Roll',
    subText: 'Originals',
    subTextColor: '#DBFE02',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/3.svg',
    text: 'Slots',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/4.svg',
    text: 'Live casino',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/5.svg',
    text: 'Roulette',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/6.svg',
    text: 'Black jack',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/7.svg',
    text: 'Battles',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/8.svg',
    text: 'Challenges',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
]
